module.exports = __webpack_public_path__ + "26e58c04f074c16185ac74cd73c8a626.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/Assets/fruithandserve.png
// module id = 1365
// module chunks = 0